import { useEffect, useState } from 'react';
import type { ApiReserveView } from '../../shared/api-reserve';
import { readApiReserve } from '../lib/boundaries/apiReserve';
import KopfMenue from './KopfMenue';

const usd = (n: number) => new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(n);

export default function ApiReserve() {
  const [view, setView] = useState<ApiReserveView | null>(null);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    let disposed = false;
    let controller: AbortController | undefined;
    const refresh = async () => {
      controller?.abort();
      controller = new AbortController();
      const timeout = window.setTimeout(() => controller?.abort(), 10_000);
      try {
        const data = await readApiReserve(controller.signal);
        if (disposed) return;
        if (data === 'forbidden') { setHidden(true); setView(null); return; }
        setHidden(false); setView(data);
      } catch { if (!disposed) setView(null); }
      finally { window.clearTimeout(timeout); }
    };
    void refresh();
    const timer = window.setInterval(refresh, 30_000);
    return () => { disposed = true; controller?.abort(); window.clearInterval(timer); };
  }, []);
  if (hidden) return null;
  const reserve = view?.reserve;
  const known = reserve && reserve.state !== 'unavailable';
  const percent = known && reserve.granted_usd > 0 ? Math.min(100, reserve.available_usd / reserve.granted_usd * 100) : 0;
  return <KopfMenue aiId="cui-api-reserve" menueTitel="Gemeinsames Gratis-API-Guthaben" breite={380}
    klasse="ki-api-reserve" knopfTitel="Gratis-API-Guthaben gemeinsam für Dev und Prod; Klick für Konten und Verwendung"
    knopf={<span><span>Gratis-API · {known ? usd(reserve.available_usd) : 'unbekannt'}</span>
      <span className="ki-api-reserve-spur" aria-hidden="true"><span style={{ width: `${percent}%` }} /></span></span>}>
    <div className="ki-api-reserve-details">
      <p>{known ? `${usd(reserve.available_usd)} verfügbar aus einem gemeinsamen Pool.` : 'Aktuell keine verlässliche Guthabenmessung.'}</p>
      {known && <p>Restguthaben: {usd(reserve.remaining_usd)} · Reserviert: {usd(reserve.reserved_usd)}. Der verfügbare Betrag berücksichtigt Sicherheitsabstände.</p>}
      <p>Dev: {view?.bridges?.dev === 'active' ? 'verbunden' : 'nicht bestätigt'} · Prod: {view?.bridges?.prod === 'active' ? 'verbunden' : 'nicht bestätigt'}</p>
      {known && <p>{reserve.eligible_accounts} von {reserve.account_count} Konten nutzbar. Gesperrte oder nicht verifizierte Konten zählen nicht zum verfügbaren Betrag.</p>}
      <p>Nur verifiziertes Gratisguthaben. Mischkonten mit gekauftem Guthaben und Konten mit automatischer Aufladung sind gesperrt.</p>
      <p>Energy: Text, Bilder und Recherche zuerst aus Gratis-API; ohne Deckung Stopp. Andere Textaufrufe: Abo → Gratis-API → warten. Kein automatischer Wechsel auf bezahlte Anbieter.</p>
      <p>Energy-Recherche: Websuche, Webseitenabruf und Bibliothek über Gratis-API. Keine bezahlten Zusatzdienste. Chat bleibt ohne Werkzeuge oder fortgesetzte Sitzung; keine zusätzliche Claude-Code-Kapazität.</p>
      {reserve?.next_expiry_at && <p>Nächster Ablauf: {new Date(reserve.next_expiry_at).toLocaleDateString('de-AT')}</p>}
      {reserve?.measured_at && <p>Guthaben gemessen: {new Date(reserve.measured_at).toLocaleString('de-AT')}</p>}
    </div>
  </KopfMenue>;
}
